import React from 'react';
import Realisations from '../components/Realisations';

const RealisationsPage = () => {
  return (
    <div className="min-h-screen pt-20">
      <Realisations />
    </div>
  );
};

export default RealisationsPage;
